import { HomeIcon } from '@heroicons/react/solid'
import Link from 'next/link'

function BreadCrumbs({ list }) {
    return (
        <div>
            <nav className="flex container m-auto mt-3" aria-label="Breadcrumb">
                <ol role="list" className="flex items-center mt-5 md:mt-0">
                    <li className="hidden md:block">
                        <div>
                            <a
                                href="/"
                                className="text-gray-400 hover:text-gray-500">
                                <HomeIcon
                                    className="flex-shrink-0 h-5 w-5"
                                    aria-hidden="true"
                                />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {list.map((page) => (
                        <li key={page.name}>
                            <div className="flex items-center">
                                <svg
                                    className="flex-shrink-0 h-5 w-5 text-gray-300"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 20"
                                    aria-hidden="true">
                                    <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                                </svg>
                                {page.current ? (
                                    <a
                                        className="uppercase md:ml-2 font-light text-gray-500"
                                        aria-current={
                                            page.current ? 'page' : undefined
                                        }>
                                        {page.name}
                                    </a>
                                ) : (
                                    <Link href={page.href}>
                                        <a
                                            className="uppercase md:ml-2 font-light text-gray-500 hover:text-gray-700"
                                            aria-current={
                                                page.current
                                                    ? 'page'
                                                    : undefined
                                            }>
                                            {page.name}
                                        </a>
                                    </Link>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
        </div>
    )
}

export default BreadCrumbs
